<ng-template [ngIf]="(createRequestStep$ | async) === 'input' && isNotManualFlow">
    <input id="text-input-field" (keypress)="onKeyPress($event)" (keydown)="onkeydown($event)" #inputShares [value]="params.value" (blur)="onchange()"
        [ngClass]="showIcon ? 'errorClass sdps-input sdps-input--small' : 'sdps-input sdps-input--small'" />
</ng-template>
<ng-template [ngIf]="(!isNotManualFlow) || (createRequestStep$ | async) === 'review' || (createRequestStep$ | async) === 'confirmation'">
    <p class='sharesToMoveClass textCell'>{{paramsString}}</p>
</ng-template>
<span class="errorText" id="errorText">{{currentValue}}</span>
<sac-tooltip *ngIf="showIcon" [position]="position" [message]="toolTipError">
    <span class="sac-tooltip-icon"></span>
</sac-tooltip>